/* eslint-disable max-len */

import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import Media from 'react-media';

import { getPageOnHostByID } from 'lib/api';
import { requireQueryByName } from 'lib/dependencies';
import { ACTION_NODE_LINK, ACTION_TYPE_PRIMARY } from 'constants/Action';
import GLOBAL_MEDIA_QUERIES from 'utils/facility';
import trackAction from 'utils/tracking';

import Cta from 'components/Core/Cta';
import Hero from 'components/Core/Hero';

import { AudienceSplitPageWrap } from './AudienceSplitPage.styles';

const AudienceSplitPage = (props) => {
  const {
    page: { linkBlockTitle, linkBlockText, heroImage, linkBlockLinks },
  } = props;

  const onClickLink = (url, label) => {
    // GTM Event
    trackAction('b2c-b2b', label, 'click');
    // set cookie
    Cookies.set('sfnPreferredHomeUrl', url);
  };

  const heroHeight = {
    xs: '300px',
    sm: '550px',
  };

  return (
    <AudienceSplitPageWrap bgImage={heroImage}>
      <Hero hero={heroImage} extraClassNames="md:hidden" heroHeight={heroHeight} />
      <div className="container mx-auto px-4">
        <div className="split-content w-full text-basic-700 absolute -mt-16 md:mt-0 sm:top-550 md:top-unset md:bottom-0 left-0">
          <div className="bg-white rounded-base rounded-b-none text-center p-4 lg:p-6 xl:p-8 xxl:p-12 lg:w-9/12 xl:w-4/6 lg:mx-auto">
            <Media queries={GLOBAL_MEDIA_QUERIES} defaultMatches={{ xs: true }}>
              {(matches) =>
                matches.xs || matches.sm ? (
                  <h1 className="my-4 h3">{linkBlockTitle}</h1>
                ) : (
                  <h1 className="my-4">{linkBlockTitle}</h1>
                )
              }
            </Media>

            <p className="text-xl lg:text-2xl lg:leading-10 my-4">{linkBlockText}</p>
            <div className="flex justify-around md:justify-center pt-4 pb-15vh md:pb-0">
              {linkBlockLinks.map((linkBlock, index) => (
                <Cta
                  className="px-8 md:mx-4 md:px-12"
                  node={ACTION_NODE_LINK}
                  href="/[...slug]"
                  as={linkBlock.page.url}
                  styleType={ACTION_TYPE_PRIMARY}
                  showIcon={false}
                  key={`split-${linkBlock.id}`}
                  data-test-id={`cta-${index}`}
                  onClick={() => {
                    onClickLink(linkBlock.page.url, linkBlock.linkText);
                  }}
                >
                  {linkBlock.linkText}
                </Cta>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AudienceSplitPageWrap>
  );
};

// The data returned here will be send as `props` to the component
// TODO: Let's see if we need this here or can ultimately adopt this into the lib/api calls directly
// That will depend on how different these calls are going to be along the way.
AudienceSplitPage.getCustomInitialProps = async ({ id, contentType, hostname, previewData }) => {
  const query = requireQueryByName('AudienceSplitPage');
  const token = previewData ? previewData.token : '';
  const { page } = await getPageOnHostByID({
    id,
    contentType,
    query,
    token,
    hostname,
  });

  return {
    page,
    isSplitPage: true,
  };
};

AudienceSplitPage.defaultProps = {
  page: {
    heroTitle: '',
    linkBlockLinks: [],
  },
};

AudienceSplitPage.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    heroImage: PropTypes.shape({}).isRequired,
    heroTitle: PropTypes.string,
    linkBlockTitle: PropTypes.string.isRequired,
    linkBlockText: PropTypes.string.isRequired,
    linkBlockLinks: PropTypes.arrayOf(
      PropTypes.shape({
        linkText: PropTypes.string,
        page: PropTypes.shape({
          title: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
        }),
        id: PropTypes.string,
      }),
    ),
  }),
};

export default AudienceSplitPage;
